export default {
    table: {
        rowItemStyle: {
            whiteSpace: 'pre-line',
        },
    },
};
